const KeyMap = {};

KeyMap.UP = 38;
KeyMap.DOWN = 40;
KeyMap.RIGHT = 39;
KeyMap.BACK_SPACE = 8;
KeyMap.RETURN = 13;
KeyMap.ENTER = 14;
KeyMap.ESCAPE = 27;
KeyMap.TAB = 9;

export default KeyMap;
